export default __webpack_public_path__ + "images/TU.9807356.png";